// extracted by mini-css-extract-plugin
module.exports =  {"arrowContainer":"F0gnUb","left":"qQmugS","right":"VM7Je0","arrow":"SO6Hte","chevron":"W8YhG2"};